/*!
 * @license
 * Copyright 2019 Alfresco, Inc. and/or its affiliates.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Pipe, PipeTransform } from '@angular/core';
/* cSpell:disable */
@Pipe({ name: 'variablevalue' })
/* cSpell:enable */
export class VariableValuePipe implements PipeTransform {
    transform(value: any): string {
        if (value === undefined || value === null) {
            return null;
        } else if (typeof value === 'object' && value.uri !== undefined) {
            return this.getFileNameFromUri(value.uri);
        } else if (typeof value === 'object' && value.uri === undefined) {
            return JSON.stringify(value);
        } else {
            return String(value);
        }
    }

    private getFileNameFromUri(uri: string): string {
        return uri.slice('file:/'.length).split('.').slice(0, -1).join('.');
    }
}
